import { render } from "./Scrollbar.vue?vue&type=template&id=2fc438ad"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/Scrollbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fc438ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fc438ad', __exports__)) {
    api.reload('2fc438ad', __exports__)
  }
  
  module.hot.accept("./Scrollbar.vue?vue&type=template&id=2fc438ad", () => {
    api.rerender('2fc438ad', render)
  })

}


export default __exports__